// @ts-check
const I18NextHttpBackend = require("i18next-http-backend/cjs");
// 与 next.config.js 的 basePath、config/basePath.ts 保持一致。
// 本文件是 CommonJS（被 next.config.js require），无法 import config/basePath.ts，故就地声明。
const BASE_PATH = "/pointsmall";

// locale key
const locales = ["sc", "tc", "en", "jp", "kr", "es", "pt", "th", "vn", "ar", "ug", "hi"];

// mts system locale key
const mtsLocales = {
  sc: "zh_cns",
  tc: "zh_cnt",
  en: "en_us",
  jp: "ja_jp",
  kr: "ko_kr",
  es: "es_es",
  pt: "pt_pt",
  th: "th_th",
  vn: "vi_vn",
  ar: "ar_ae",
  ug: "ug_cn",
  hi: "in_id",
};

/**
 * @type {import('next-i18next').UserConfig}
 */
const nextI18NextConfig = {
  // https://www.i18next.com/overview/configuration-options#logging
  // debug: process.env.NODE_ENV === "development",
  // debug: true,
  debug: false,
  i18n: {
    defaultLocale: process.env.SITE === "cn" ? "sc" : "en",
    locales: locales,
  },
  reloadOnPrerender: process.env.NODE_ENV === "development",
  ns: [process.env.NEXT_PUBLIC_MTS_NS || "defaultNamespace"],
  defaultNS: process.env.NEXT_PUBLIC_MTS_NS,
  backend: {
    loadPath: (lngs, ns) => {
      const lng = mtsLocales[lngs[0]];
      // const remoteMTTSUrl = `${process.env.NEXT_PUBLIC_MTS_HOST}/${lng}.json`; // test wrong url
      const remoteMTTSUrl = `${process.env.NEXT_PUBLIC_MTS_HOST}/${process.env.NEXT_PUBLIC_MTS_NS}/${process.env.NEXT_PUBLIC_MTS_VERSION}/${lng}.json`;
      return remoteMTTSUrl;
    },
    request: (options, url, payload, callback) => {
      // 直接从 URL 解析出 MTS 语言代码，然后映射回本地代码
      const getOriginalLngFromUrl = (url) => {
        try {
          const filename = url.split("/").pop();
          const mtsLngCode = filename.replace(".json", "");
          // 反向查找：从 mtsLocales 的值找到对应的键
          for (const [localLng, mtsLng] of Object.entries(mtsLocales)) {
            if (mtsLng === mtsLngCode) {
              return localLng;
            }
          }
          return "sc";
        } catch (error) {
          console.error("❌ URL 解析失败:", error);
          return "sc";
        }
      };
      const originalLng = getOriginalLngFromUrl(url);
      // public/ 下的文件实际服务在 basePath 之下（/pointsmall/locales/*.json）。
      // <link>、fetch 这类手写的根路径 URL 不会被 Next 自动加前缀，漏了就 404，
      // 兜底链会一路退到空数据、页面直接显示 i18n key。
      const getLocalUrl = (lng) => {
        if (typeof window !== "undefined") {
          return `${window.location.origin}${BASE_PATH}/locales/${lng}.json`;
        }
        const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000";
        return `${baseUrl}${BASE_PATH}/locales/${lng}.json`;
      };

      fetch(url, {
        method: "GET",
        cache: "no-cache",
        credentials: "same-origin",
        mode: "cors",
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error(`HTTP ${response.status}`);
        })
        .then((data) => {
          // console.log("✅ 远端加载成功");
          callback(null, {
            status: 200,
            data: data,
          });
        })
        .catch((error) => {
          console.log("❌ 远端失败:", error.message);
          const localUrl = getLocalUrl(originalLng);
          console.log("📁 本地文件URL:", localUrl);
          fetch(localUrl, {
            method: "GET",
            cache: "no-cache",
          })
            .then((response) => {
              if (response.ok) {
                return response.json();
              }
              throw new Error(`本地文件 HTTP ${response.status}`);
            })
            .then((localData) => {
              callback(null, {
                status: 200,
                data: localData,
              });
            })
            .catch((localError) => {
              console.error("💥 本地文件加载失败", localError);
              // 尝试加载默认语言
              const defaultLocalUrl = getLocalUrl("sc");
              console.log("🔄 尝试默认语言文件:", defaultLocalUrl);
              fetch(defaultLocalUrl, {
                method: "GET",
                cache: "no-cache",
              })
                .then((response) => {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error("默认语言文件加载失败");
                })
                .then((defaultData) => {
                  console.log("✅ 使用默认语言文件成功");
                  callback(null, {
                    status: 200,
                    data: defaultData,
                  });
                })
                .catch((defaultError) => {
                  console.error("💥 默认语言文件加载失败", defaultError);
                  console.log("⚠️ 使用空数据作为最终回退");
                  callback(null, {
                    status: 200,
                    data: {},
                  });
                });
            });
        });
    },
    reloadInterval: process.env.NEXT_PUBLIC_RELOAD_INTERVAL || 1000 * 60 * 30,
  },
  serializeConfig: false,
  use: [I18NextHttpBackend],
};

module.exports = {
  ...nextI18NextConfig,
  mtsLocales: mtsLocales,
  locales: locales,
};
